import { validVideoDimensions, videoFrameStyle, type VideoDimensions } from './videoLayout';

export interface EmbedVideo extends VideoDimensions {
  id: string;
  title: string;
}

export function escapeHtmlAttribute(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;');
}

function absoluteUrl(origin: string, path: string): string {
  return new URL(path, `${origin.replace(/\/$/, '')}/`).href;
}

export function iframeEmbedCode(video: EmbedVideo, origin: string): string {
  const src = escapeHtmlAttribute(absoluteUrl(origin, `/embed/${encodeURIComponent(video.id)}`));
  const title = escapeHtmlAttribute(video.title);
  const layout = videoFrameStyle(video);
  const ratio = layout.aspectRatio.replaceAll(' ', '');
  return `<iframe src="${src}" title="${title}" loading="lazy" referrerpolicy="strict-origin-when-cross-origin" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="display:block;width:100%;${layout.maxWidth ? `max-width:${layout.maxWidth};` : ''}aspect-ratio:${ratio};border:0"></iframe>`;
}

export function scriptEmbedCode(video: EmbedVideo, origin: string, iframeOrigin = origin): string {
  const id = escapeHtmlAttribute(video.id);
  const title = escapeHtmlAttribute(video.title);
  const src = escapeHtmlAttribute(absoluteUrl(origin, '/embed.js'));
  const customOrigin = iframeOrigin !== origin ? ` data-streamline-embed-origin="${escapeHtmlAttribute(new URL(iframeOrigin).origin)}"` : '';
  const dimensions = validVideoDimensions(video) ? ` data-streamline-width="${video.width}" data-streamline-height="${video.height}"` : '';
  return `<div data-streamline-video="${id}" data-streamline-title="${title}"${customOrigin}${dimensions}></div>\n<script async src="${src}"></script>`;
}
